const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const InspiredCondition = require('../../conditions/InspiredCondition');
const { logError } = require('../../logger');

const AngelMask = function (battleState) {
  this.handle = 'angel_mask';
  this.magic = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = () => true;

  this.execute = (actor) => {
    if (!actor || !actor.inPlay) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getPassiveAbility(actor, this.handle);
      const inspiredConditions = [];
      for (const victim of BattleCalc.getAlliesOfUnit(
        actor,
        battleState.allUnits,
        true
      )) {
        if (BattleCalc.boardDistance(victim, actor) <= ability.effectRange) {
          if (!alreadyInspired(actor, victim)) {
            const c = new InspiredCondition(
              actor,
              victim,
              battleState,
              ability.potency
            );
            battleState.onUnitCondition(c);
            inspiredConditions.push(c);
          }
        } else {
          // out of effect range, so expire any inspired conditions of which i am the instigator
          for (const c of Object.values(victim.conditions || {})) {
            if (c.handle === 'inspired' && c.instigatorId === actor.uid) {
              battleState.expireCondition(c.uid);
            }
          }
        }
      }

      const result = { inspiredConditions };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
      return result;
    } catch (err) {
      logError(err, {
        module: 'AngeLMask',
        func: 'execute',
        actor,
      });

      return { success: false };
    }
  };
};
module.exports = AngelMask;

function alreadyInspired(actor, potential_victim) {
  for (const c of Object.values(potential_victim.conditions || {})) {
    if (c.handle === 'inspired' && c.instigatorId === actor.uid) {
      return true;
    }
  }
  return false;
}
